/* eslint-disable no-restricted-imports */
import {useUIGameEndContext} from '../../../../contexts/UIGameEndContext'
import React, {useMemo} from 'react'
import styles from './PlayerTable.module.scss'
import {Avatar} from '../../../../common/Avatar'
import {EndGamePlayerState} from '@colonist/game-states'
import clsx from 'clsx'
import {LocationFlag, T, Tooltip, useUIGlobalContext} from '@colonist/ui'
import {UIGamePlayerOptionsDropdown} from '../../../../common/UIGamePlayerOptionsDropdown'
import {ClientUserState} from '../../../../../../../code/client/shared/scripts/ClientUserState'
import IconTrophy from '@static/images/icon_trophy.svg'
import {useGameStore} from '../../../../store/GameStoreContext'
import {usePlayerValidators} from '../../../../store/selectors/usePlayerValidators'

const Player = ({player}: {player: EndGamePlayerState}) => {
    const isRanked = useGameStore((state) => state.gameDetails.isRanked)
    const {getPlayerValidator} = usePlayerValidators()
    const playerValidator = getPlayerValidator(player.color)
    const isCurrentUser = playerValidator?.isUser && playerValidator?.userState.userId === ClientUserState.userState?.id
    const {isUserOnDiscord, isUserOnMobileAppOrWeb} = useUIGlobalContext()
    const shouldShowCountryFlag = useMemo(() => {
        if(!isRanked) return false
        if(playerValidator?.userState.regionUpdated != undefined) return true
        if(playerValidator?.isPlayingOnDiscord) return false
        if(playerValidator?.userState.countryCode == null) return false
        return true
    }, [isRanked, playerValidator])

    if(playerValidator.userState.isBot) {
        return <div className={styles.playerInfo}>
            <Avatar
                className={styles.avatar}
                color={player.color}
                image={playerValidator.userState.databaseIcon}
            />
            <div className={clsx(styles.name, styles.botName)}>{playerValidator.username}</div>
        </div>
    }

    const showPlusIcon = !(
        isUserOnMobileAppOrWeb
            || playerValidator.isLocalDiscordPlayer
            || playerValidator.userState.isBot
            || isCurrentUser
    )

    return <UIGamePlayerOptionsDropdown
        className={styles.playerInfo}
        // eslint-disable-next-line i18next/no-literal-string
        excludeOptions={['blockTrades', 'mute']}
        isInternalDiscordGift
        playerValidator={playerValidator}>
        <Avatar
            className={styles.avatar}
            color={player.color}
            image={playerValidator.userState.databaseIcon}
            membership={playerValidator.userState.membership}
            profilePictureUrl={playerValidator.userState.profilePictureUrl}
            showPlusIcon={showPlusIcon}
        />
        <div className={styles.name}>{playerValidator.username}</div>
        {
            shouldShowCountryFlag &&
               <LocationFlag
                   className={styles.countryFlag}
                   location={{countryCode: playerValidator.userState.countryCode}}
                   isUserOnDiscord={isUserOnDiscord}
               />
        }
    </UIGamePlayerOptionsDropdown>
}

export const PlayerTable = () => {
    const {playersByRank} = useUIGameEndContext()

    return <div className={styles.container}>
        <div className={styles.row}>
            <div />
            <Tooltip centerText title={<T id={{key: 'strings:game.endGame.icons.trophy'}}/>} >
                <img className={styles.trophyIcon}
                    src={IconTrophy}
                />
            </Tooltip>
        </div>
        {playersByRank.map((player) => (
            <div className={styles.row} key={player.color}>
                <Player player={player} />
                <div className={styles.victoryPoint}>
                    {player.totalVictoryPoints}
                </div>
            </div>
        ))}
    </div>
}
